import { z } from "zod";
import { VALIDATION_KEYS as VK } from "@fysaro/shared";
import { EXCEPTION_TYPES } from "@fysaro/shared";

const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

export const createAvailabilityExceptionSchema = z
  .object({
    professionalId: z.string().uuid(VK.GENERIC.UUID),
    startDate: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, VK.EXCEPTION.INVALID_DATE),
    endDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, VK.EXCEPTION.INVALID_DATE),
    isClosed: z.boolean().optional().default(true),
    startTime: z.string().nullable().default(null),
    endTime: z.string().nullable().default(null),
    type: z.enum(EXCEPTION_TYPES),
    description: z.string().min(1, VK.GENERIC.REQUIRED),
  })
  .strict()
  .superRefine((data, ctx) => {
    // 1. Validar orden de fechas (Rango)
    if (data.startDate > data.endDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: VK.EXCEPTION.DATE_ORDER, // Necesitarás crear esta key o usar una similar
        path: ["endDate"],
      });
    }

    // 2. Lógica de Horas vs Cierre
    if (!data.isClosed) {
      // Si NO está cerrado, las horas son obligatorias
      if (!data.startTime || !timeRegex.test(data.startTime)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: VK.EXCEPTION.TIME_FORMAT,
          path: ["startTime"],
        });
      }
      if (!data.endTime || !timeRegex.test(data.endTime)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: VK.EXCEPTION.TIME_FORMAT,
          path: ["endTime"],
        });
      }
      if (data.startTime && data.endTime && data.startTime >= data.endTime) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: VK.EXCEPTION.TIME_ORDER,
          path: ["endTime"],
        });
      }
    }
  });

export const updateAvailabilityExceptionSchema =
  createAvailabilityExceptionSchema;
